const localeStringReplacement = (string, replaceableData) => {
  return Object.entries(replaceableData).reduce((newString, [key, value]) => {
    return newString.replaceAll(`{{${key}}}`, value);
  }, string);
};
export { localeStringReplacement };
